import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => createStyles({
  historyChipWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    background: '#E8E4FB',
    border: '1px solid #D7D1FF',
    borderRadius: '9999px',
    padding: '3px 10px',
    fontSize: '11px',
    fontWeight: '700',
    color: '#2E2A66',
    letterSpacing: '0.3px',
    textTransform: 'uppercase',
  },
  dot: (props: {color?: string}) => ({
    width: '7px',
    height: '7px',
    borderRadius: '50%',
    background: props?.color || 'none',
    flexShrink: '0',
  }),
}));
